export default [
  "Compliance with EN 378-1:2016, C.3.1 & C3.2",
  "1 Additional Protective Measure + Leak Detection (EN 378-1:2016, C.3.2.2)",
  "2 Additional Protection Measures + Leak Detection (EN 378-1:2016, C.3.2.2)",
  "No additional protective measures required",
  "EN 378-3:2016, 4.2 open air or 4.3 machinery room construction requirements apply",
  "Proposed System Charge Size",
  "Charge Size Not Compliant",
];
